/*
 * EvenemangPageConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const CHANGE_USERNAME = 'boilerplate/EvenemangPage/CHANGE_USERNAME';
export const TO_LIST = 'boilerplate/EvenemangPage/TO_LIST';
export const TO_MASONRY = 'boilerplate/EvenemangPage/TO_MASONRY';
export const CHANGE_PAGE = 'boilerplate/EvenemangPage/CHANGE_PAGE';
export const CHANGE_PAGESIZE = 'boilerplate/EvenemangPage/CHANGE_PAGESIZE';
export const CHANGE_MORE = 'boilerplate/EvenemangPage/CHANGE_MORE';
